if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {

      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      const formData = new FormData(this.form);
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      var frequencyInput = '#rc_shipping_interval_frequency';
      var unitType = '#rc_shipping_interval_unit_type';
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      console.log($(this).parents(".elevate-cup").length);
      if( $(this).parents(".elevate-cup").length > 0){
        var productType = this.form.querySelector('[name=purchase_type]:checked').value;
        console.log(productType);

        if(productType != undefined || productType != null ){
          if(productType == 'autodeliver'){

            formData.append('properties[shipping_interval_unit_type]',this.form.querySelector(unitType).value);
            formData.append('properties[shipping_interval_frequency]',this.form.querySelector(frequencyInput).value);

          }
        }
      }




      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      console.log(config);
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

  });
  $('body input[name="purchase_type"]').change(function(){
    // console.log(123);
    // console.log($(this).val());

    if($(this).val()=='onetime'){
      $('#rc_shipping_interval_frequency').attr("disabled","disabled");
      $('#rc_shipping_interval_unit_type').attr("disabled","disabled");
    }else{
      $('#rc_shipping_interval_frequency').removeAttr("disabled");
      $('#rc_shipping_interval_unit_type').removeAttr("disabled");
    }
  });
}
